// Albanian for the T("english") words on the screens EduTask shares with Marine and DAMA (records, activity, Build,
// operations), looked up by their English. Standard Albanian. Anything missing here shows in English.
export const SQ_TEXT: Record<string, string> = {
  // Records, Home and Activity
  "VERA's server didn't answer. Please try again.": "Serveri i VERA-s nuk u përgjigj. Të lutem provo përsëri.",
  "Your records appear here with live VERA.": "Regjistrat e tu shfaqen këtu kur VERA është aktive.",
  "Tell VERA": "Thuaji VERA-s",
  "Ask VERA": "Pyet VERA-n",
  "Open work": "Punë të hapura",
  "Loading…": "Po ngarkohet…",
  "Nothing open. Tell VERA about the next one.": "Asgjë e hapur. Tregoji VERA-s për të radhës.",
  "Latest changes": "Ndryshimet e fundit",
  "See all": "Shiko të gjitha",
  "Nothing yet. Every change VERA or the team makes shows here.": "Asgjë ende. Çdo ndryshim që bën VERA ose ekipi shfaqet këtu.",
  "Records": "Regjistrat",
  "No record types yet. Tell VERA how you work and she'll set them up.": "Ende nuk ka lista. Tregoji VERA-s si punoni dhe ajo i krijon.",
  "Tell VERA how your work is organized": "Tregoji VERA-s si e organizoni punën",
  "Your CRM, shaped by VERA. Click a row to see or change it, or tell VERA.": "CRM-ja juaj, e ndërtuar nga VERA. Kliko një rresht për ta parë ose ndryshuar, ose thuaji VERA-s.",
  "Record types": "Listat",
  "Nothing matches.": "Asgjë nuk përputhet.",
  "Given to": "Caktuar për",
  "Changed": "Ndryshuar",
  "Someone": "Dikush",
  "Saved.": "U ruajt.",
  "Removed. Undo it from Activity if needed.": "U hoq. Mund ta zhbësh te Aktiviteti nëse duhet.",
  "Close": "Mbyll",
  "Nobody yet": "Askush ende",
  "version": "versioni",
  "Cancel": "Anulo",
  "Saving…": "Po ruhet…",
  "Save": "Ruaj",
  "Add": "Shto",
  "Remove": "Hiq",
  "Edit": "Ndrysho",
  "Yes": "Po",
  "No": "Jo",
  "None yet. VERA files photos from the glasses here.": "Asnjë ende. VERA i ruan këtu fotot nga syzet.",
  "Photo from the field": "Foto nga terreni",
  "From the field": "Nga terreni",
  "Video from the field": "Video nga terreni",
  "What people showed VERA through their glasses. VERA files each photo on the right record.": "Çfarë i treguan njerëzit VERA-s përmes syzeve. VERA e ruan secilën foto te regjistri i duhur.",
  "Undone.": "U zhbë.",
  "Activity": "Aktiviteti",
  "Every change in your workspace: who, how and when. Undo anything that shouldn't have happened.": "Çdo ndryshim në hapësirën tuaj: kush, si dhe kur. Zhbëj çdo gjë që nuk duhej të ndodhte.",
  "The changes you made in your workspace.": "Ndryshimet që ke bërë në hapësirën tënde.",
  "No changes yet.": "Ende nuk ka ndryshime.",
  "When": "Kur",
  "What": "Çfarë",
  "Who": "Kush",
  "How": "Si",
  "undone": "zhbërë",
  "Undo": "Zhbëj",
  "in Studio": "në Studio",
  "by VERA": "nga VERA",
  "by voice": "me zë",
  "from the glasses": "nga syzet",
  "by import": "me import",
  "in Build mode": "në Build",
  "in the staff app": "në aplikacionin e stafit",
  'Tell VERA, e.g. "Add the Erasmus+ KA2 call, deadline 15 March, and link it to the University of Prishtina"': "Thuaji VERA-s, p.sh. «Shto thirrjen Erasmus+ KA2 me afat 15 mars dhe lidhe me Universitetin e Prishtinës»",

  // Build
  "Not added:": "Nuk u shtua:",
  "Turn on the microphone in Privacy first.": "Së pari aktivizo mikrofonin te Privatësia.",
  "Dictation couldn't start.": "Diktimi nuk mundi të fillonte.",
  "VERA is planning the change…": "VERA po e planifikon ndryshimin…",
  "VERA didn't answer. Please try again.": "VERA nuk u përgjigj. Të lutem provo përsëri.",
  "Not everything went in:": "Jo gjithçka u shtua:",
  "That didn't apply. Nothing changed.": "Kjo nuk u zbatua. Asgjë nuk ndryshoi.",
  "Undone. The workspace is back as it was.": "U zhbë. Hapësira është si më parë.",
  "Couldn't undo it.": "Nuk u zhbë dot.",
  "Set up my workspace for what's attached.": "Përgatite hapësirën time sipas asaj që bashkëngjita.",
  "Build mode": "Build",
  "Close Build mode": "Mbyll Build",
  "Build mode is for the workspace's owners. Ask an owner if something should be set up differently.": "Build është për pronarët e hapësirës. Pyet një pronar nëse diçka duhet ndryshuar.",
  "Tell VERA how your workspace should work: new lists, fields, choices, names, or what your crew sees. Attach a paper form or a photo and she'll set it up from that. You'll see the change before it happens, and you can undo it.":
    "Thuaji VERA-s si duhet të funksionojë hapësira juaj: lista të reja, fusha, zgjedhje, emra ose çfarë sheh ekipi. Bashkëngjit një formular ose një foto dhe ajo e përgatit sipas saj. E sheh ndryshimin para se të ndodhë dhe mund ta zhbësh.",
  "Applying…": "Po zbatohet…",
  "Apply": "Zbato",
  "Not now": "Jo tani",
  "Attach images, files or documents": "Bashkëngjit foto, skedarë ose dokumente",
  "Send": "Dërgo",

  // Operations
  "Operations": "Operacionet",
  "What your company costs this month, line by line. Everything except VERANeural's fee is passed through at cost.": "Sa kushton kompania juaj këtë muaj, rresht për rresht. Gjithçka përveç tarifës së VERANeural paguhet me koston reale.",
  "Costs appear here with live VERA.": "Kostot shfaqen këtu kur VERA është aktive.",
  "Switched on.": "U aktivizua.",
  "Switched off.": "U çaktivizua.",
  "Total for": "Gjithsej për",
  "so far this month": "deri tani këtë muaj",
  "Passed through at cost": "Me koston reale",
  "Azure, VERA's engine and outside services": "Azure, motori i VERA-s dhe shërbimet e jashtme",
  "VERANeural platform fee": "Tarifa e platformës VERANeural",
  "Fixed monthly fee": "Tarifë fikse mujore",
  "Your Azure resources": "Burimet tuaja në Azure",
  "Nothing charged yet this month.": "Asgjë e faturuar ende këtë muaj.",
  "Outside services": "Shërbime të jashtme",
  "None. Services like Meta or phone numbers show here when VERANeural pays them for you.": "Asnjë. Shërbime si Meta ose numrat e telefonit shfaqen këtu kur VERANeural i paguan për ju.",
  "VERA's engine": "Motori i VERA-s",
  "Every answer, voice conversation and model token, counted as it happens. Model tokens are exact; lines marked estimate use an average per use.": "Çdo përgjigje, bisedë me zë dhe token i modelit, i numëruar kur ndodh. Tokenët janë të saktë; rreshtat me shënimin vlerësim përdorin një mesatare për përdorim.",
  "Nothing used yet this month.": "Asgjë e përdorur ende këtë muaj.",
  "Resources": "Burimet",
  "Switch off what you don't need: VERA stops using it at once, and it stops costing anything.": "Çaktivizo atë që nuk të duhet: VERA ndalon ta përdorë menjëherë dhe nuk kushton më asgjë.",
  "Your company's owner switches these on or off.": "Pronari i kompanisë i aktivizon ose çaktivizon këto.",
  "VERA's answers always stay on.": "Përgjigjet e VERA-s mbeten gjithmonë aktive.",
  "On": "Aktiv",
  "Off": "Joaktiv",
  "Live from Azure and VERA's meters · updated": "Drejtpërdrejt nga Azure dhe matësit e VERA-s · përditësuar",
  "Total": "Gjithsej",
  "Cost": "Kosto",
  "How much": "Sa",
  "estimate": "vlerësim",
  "Answers from VERA": "Përgjigje nga VERA",
  "Voice conversations": "Biseda me zë",
  "Dictation": "Diktim",
  "Photos from the field": "Foto nga terreni",
  "CRM actions by voice": "Veprime në CRM me zë",
  "Web pages read": "Faqe interneti të lexuara",
  "Web reading": "Leximi i uebit",
  "Gamma decks": "Prezantime Gamma",
  "Workflow runs": "Ekzekutime të proceseve",
  "Workflows": "Proceset e punës",
  "Imports": "Importe",
  "Build mode requests": "Kërkesa në Build",
  "VERA Code: Build mode": "VERA Code: Build",
  "Covered by the model tokens above": "Përfshirë te tokenët e modelit më lart",
  "Talking with VERA live, in Studio and on the glasses (Azure realtime voice).": "Bisedë e drejtpërdrejtë me VERA-n, në Studio dhe me syze (zëri në kohë reale i Azure).",
  "Speaking instead of typing (Azure speech to text).": "Fol në vend që të shkruash (Azure, nga zëri në tekst).",
  "Photos from the glasses or phone, stored for the company.": "Foto nga syzet ose telefoni, të ruajtura për kompaninë.",
  "VERA reading web pages and searching the web (Bing grounding).": "VERA lexon faqe interneti dhe kërkon në ueb (Bing).",
  "VERA reshaping the company's own records on request.": "VERA ndryshon listat e kompanisë sipas kërkesës.",
  "Multi-step work VERA runs for the company.": "Punë me disa hapa që VERA kryen për kompaninë.",
  "Presentations made with the company's own Gamma account.": "Prezantime të bëra me llogarinë Gamma të kompanisë.",
  "uses": "përdorime",
  "tokens": "tokenë",
  "pages or searches": "faqe ose kërkime",
  "conversations": "biseda",
  "photos": "foto",
  "dictations": "diktime",
  "Servers (Container Apps)": "Serverët (Container Apps)",
  "Database (PostgreSQL)": "Baza e të dhënave (PostgreSQL)",
  "App images (Container Registry)": "Imazhet e aplikacionit (Container Registry)",
  "File storage": "Ruajtja e skedarëve",
  "Secrets (Key Vault)": "Sekretet (Key Vault)",
  "AI models": "Modelet e AI-së",
  "Web apps (App Service)": "Aplikacione uebi (App Service)",
  "Service Fusion · your jobs and schedule": "Service Fusion · punët dhe orari juaj",
  "An owner of your workspace brings in Service Fusion.": "Një pronar i hapësirës suaj të punës sjell Service Fusion.",
  "Customers, boats, jobs with materials, notes and checklists, estimates and invoices": "Klientë, varka, punë me materiale, shënime dhe lista kontrolli, preventiva dhe fatura",
  "Bring in Service Fusion": "Sill Service Fusion",
  "VERA reads your customers, boats and all your jobs from Service Fusion (with the materials and services used, notes, checklists and job categories), your estimates and your invoices, and shows you what would come in. Run it again any time to bring in what's new; what's already here stays as it is. Nothing is saved until you say so.": "VERA lexon klientët, varkat dhe të gjitha punët tuaja nga Service Fusion (me materialet dhe shërbimet e përdorura, shënimet, listat e kontrollit dhe kategoritë e punëve), preventivat dhe faturat tuaja, dhe ju tregon çfarë do të vinte. Mund ta përsërisni kur të doni për të sjellë të rejat; ajo që është tashmë këtu mbetet siç është. Asgjë nuk ruhet pa miratimin tuaj.",
  "VERA reads your whole Service Fusion history: customers, boats, every job with the materials used, notes and checklists, your estimates and your invoices (paid and unpaid). She shows you what would come in first; nothing is saved until you say so, and one undo in Activity takes it back.": "VERA lexon gjithë historikun tuaj në Service Fusion: klientët, varkat, çdo punë me materialet e përdorura, shënimet dhe listat e kontrollit, preventivat dhe faturat tuaja (të paguara dhe të papaguara). Ajo ju tregon fillimisht çfarë do të vinte; asgjë nuk ruhet pa miratimin tuaj, dhe një zhbërje te Aktiviteti e kthen gjithçka pas.",
  "Bring in from Service Fusion": "Sill nga Service Fusion",
  "Look at Service Fusion": "Shiko Service Fusion",
  "Reading Service Fusion… this can take a minute.": "Po lexohet Service Fusion… kjo mund të zgjasë një minutë.",
  "VERA would add": "VERA do të shtonte",
  "Everything in Service Fusion is already here.": "Gjithçka nga Service Fusion është tashmë këtu.",
  "already here stay as they are.": "tashmë këtu mbeten siç janë.",
  "Your fields": "Fushat tuaja",
  "New statuses": "Statuse të reja",
  "(added to Jobs)": "(shtuar te Punët)",
  "Work given to": "Puna u dha te",
  "Not signed in yet": "Ende pa hyrë",
  ": their names go in the job's notes, so you can give them the work once they sign in.": ": emrat e tyre shkojnë te shënimet e punës, që t'ua jepni punën sapo të hyjnë.",
  "things to know": "gjëra për t'u ditur",
  "Bringing it in…": "Po sillet…",
  "VERA Build": "VERA Build",
  "Almost there": "Pothuajse gati",
  "You're signed in as": "Keni hyrë si",
  ", but you don't have a VERA Studio role yet. Ask Eva or Art to add you.": ", por ende nuk keni rol në VERA Studio. Kërkojini Evës ose Artit t'ju shtojnë.",
  "Sign out": "Dil",
  "Studio navigation": "Navigimi i Studios",
  "VERA Studio": "VERA Studio",
  "VERA for desktop": "VERA për desktop",
  "Open menu": "Hap menunë",
  "Ctrl K": "Ctrl K",
  "VERA Code: change Studio's code from here": "VERA Code: ndrysho kodin e Studios nga këtu",
  "VERA Code": "VERA Code",
  "Build mode: change how your workspace works, in plain words": "Mënyra Build: ndryshoni me fjalë të thjeshta si funksionon hapësira juaj e punës",
  "Build": "Build",
  "This is the demo: sample people and sample data.": "Ky është demo: njerëz dhe të dhëna shembull.",
  "VERA's full intelligence connects soon. Today she shows your real email, calendar, Teams, Planner and files, and tells you plainly what she can't do yet. Project overviews are samples.": "Inteligjenca e plotë e VERA-s lidhet së shpejti. Sot ajo tregon emailin, kalendarin, Teams, Planner dhe skedarët tuaj të vërtetë dhe ju thotë qartë çfarë nuk mund të bëjë ende. Përmbledhjet e projekteve janë shembuj.",
  "Demo": "Demo",
  "VERA preview": "Parapamje e VERA-s",
  "View as": "Shiko si",
  "Ask VERA anything": "Pyete VERA-n për çdo gjë",
  "Google Calendar": "Google Calendar",
  "Microsoft Teams": "Microsoft Teams",
  "Platforms at a glance": "Platformat me një shikim",
  "Sample": "Shembull",
  "All projects": "Të gjitha projektet",
  "Next:": "Më pas:",
  "Saved to {where}": "U ruajt te {where}",
  "Excel workbook downloaded": "Libri Excel u shkarkua",
  "Couldn't create the Excel file. Please try again.": "Skedari Excel nuk u krijua. Ju lutem provoni përsëri.",
  "Saved {where}": "U ruajt {where}",
  "Connect Outlook in Connections, and VERA can save this in your Drafts.": "Lidhni Outlook te Lidhjet, dhe VERA mund ta ruajë këtë te Draftet tuaja.",
  "Saved in your Outlook Drafts. Add recipients and send it when you're ready.": "U ruajt te Draftet tuaja në Outlook. Shtoni marrësit dhe dërgojeni kur të jeni gati.",
  "Task": "Detyrë",
  "R does the work · A owns the outcome (one per task) · C gives input · I is kept informed.": "R e kryen punën · A mban përgjegjësinë për rezultatin (një për detyrë) · C jep kontribut · I mbahet i informuar.",
  "Wk": "Java",
  "Put in Outlook drafts": "Vendos te draftet e Outlook",
  "Send to Planner": "Dërgo te Planner",
  "{n} min faster than usual": "{n} min më shpejt se zakonisht",
  "{n} min slower than usual": "{n} min më ngadalë se zakonisht",
  "SharePoint & OneDrive": "SharePoint & OneDrive",
  "VERA can now read \"{name}\" when you ask.": "VERA tani mund ta lexojë \"{name}\" kur ta kërkoni.",
  "Removed \"{name}\". VERA can no longer read it.": "\"{name}\" u hoq. VERA nuk mund ta lexojë më.",
  "This file can't be previewed here. To have VERA read a PDF, Word, Excel or PowerPoint file, attach it in a conversation.": "Ky skedar nuk mund të shfaqet këtu. Që VERA të lexojë një skedar PDF, Word, Excel ose PowerPoint, bashkëngjiteni në një bisedë.",
  "Couldn't open that file.": "Ai skedar nuk u hap.",
  "There's nothing VERA can read in this folder yet. Open a subfolder, or tick a text, CSV or code file.": "Në këtë dosje ende nuk ka asgjë që VERA mund të lexojë. Hapni një nëndosje ose zgjidhni një skedar teksti, CSV ose kodi.",
  "Couldn't read those files.": "Ata skedarë nuk u lexuan.",
  "Folders VERA can read": "Dosjet që VERA mund të lexojë",
  "Add a folder": "Shto një dosje",
  "No folders yet. Add one, such as your client folder or job sheets. You can remove it any time.": "Ende pa dosje. Shtoni një, për shembull dosjen e klientëve ose fletët e punës. Mund ta hiqni kurdo.",
  "VERA reads only the folders listed here, and only when you ask. Files are sent to VERA, in VERANeural's own cloud, only for the question you ask about them.": "VERA lexon vetëm dosjet e listuara këtu, dhe vetëm kur ta kërkoni. Skedarët i dërgohen VERA-s, në cloud-in e VERANeural, vetëm për pyetjen që bëni për to.",
  "Choose a folder to browse it.": "Zgjidhni një dosje për ta shfletuar.",
  "Back": "Kthehu",
  "\n\n… (showing the first part)": "\n\n… (po shfaqet pjesa e parë)",
  "Show in folder": "Shfaq në dosje",
  "Include {name} in the question": "Përfshi {name} në pyetje",
  "Folder": "Dosje",
  "Not readable yet": "Ende jo e lexueshme",
  "This folder is empty.": "Kjo dosje është bosh.",
  "Ask VERA about {what}…": "Pyete VERA-n për {what}…",
  "Ask VERA about {what}": "Pyete VERA-n për {what}",
  "Reading…": "Po lexohet…",
  "Ask": "Pyet",
  "VERA will read {name}.": "VERA do të lexojë {name}.",
  "VERA will read the {n} files you ticked.": "VERA do të lexojë {n} skedarët që zgjodhët.",
  "VERA will read the file you ticked.": "VERA do të lexojë skedarin që zgjodhët.",
  "VERA will read {n} files in this folder.": "VERA do të lexojë {n} skedarë në këtë dosje.",
  "VERA will read the file in this folder.": "VERA do të lexojë skedarin në këtë dosje.",
  "Only the first 10; tick files to choose.": "Vetëm 10 të parët; zgjidhni skedarët.",
  "Tick files to choose.": "Zgjidhni skedarët.",
  "Open a file or a folder with text, CSV or code files.": "Hapni një skedar ose një dosje me skedarë teksti, CSV ose kodi.",
  "The answer opens in Workspace and is saved in your history.": "Përgjigjja hapet te Hapësira e punës dhe ruhet në historikun tuaj.",
  "Send from Excel": "Dërgo nga Excel",
  "Add task": "Shto detyrë",
  "Plan with VERA": "Planifiko me VERA-n",
  "Connect Microsoft Planner": "Lidh Microsoft Planner",
  "See your real tasks here, and let VERA create the ones you approve.": "Shihni detyrat tuaja të vërteta këtu dhe lëreni VERA-n të krijojë ato që miratoni.",
  "Open Connections": "Hap Lidhjet",
  "Loading your tasks…": "Po ngarkohen detyrat tuaja…",
  "Assigned to me": "Të caktuara për mua",
  " · due {date}": " · afati {date}",
  " · overdue": " · me vonesë",
  "more in Planner": "të tjera në Planner",
  "Nothing is assigned to you. Choose a plan above to see all its tasks.": "Nuk ju është caktuar asgjë. Zgjidhni një plan më lart për të parë të gjitha detyrat e tij.",
  "Nothing here.": "Asgjë këtu.",
  "VERA noticed:": "VERA vuri re:",
  "of your tasks": "nga detyrat tuaja",
  "tasks in this plan": "detyra në këtë plan",
  "Want help deciding what to move?": "Doni ndihmë për të vendosur çfarë të shtyni?",
  "Live from Microsoft Planner": "Drejtpërdrejt nga Microsoft Planner",
  "Task created in Planner.": "Detyra u krijua në Planner.",
  "New Planner task": "Detyrë e re në Planner",
  "Plan": "Plan",
  "Loading your plans…": "Po ngarkohen planet tuaja…",
  "No plans found": "Nuk u gjetën plane",
  "Submit Consumer 2.0 for App Store review": "Dorëzo Consumer 2.0 për shqyrtim në App Store",
  "Due (optional)": "Afati (opsional)",
  "Assign to me": "Ma cakto mua",
  "Creating…": "Po krijohet…",
  "Create task": "Krijo detyrë",
  "Done": "Kryer",
  "· due": "· afati",
  "Nothing here yet.": "Ende asgjë këtu.",
  "Sample data. Connect Microsoft Planner in Connections to see your real plans.": "Të dhëna shembull. Lidhni Microsoft Planner te Lidhjet për të parë planet tuaja të vërteta.",
  "No plans shared with you yet.": "Ende nuk është ndarë asnjë plan me ju.",
  "Bring in {what}": "Sill {what}",
  "Turn on the microphone in Privacy & consent first.": "Aktivizoni më parë mikrofonin te Privatësia dhe pëlqimi.",
  "VERA filled in the form. Check it and save.": "VERA e plotësoi formularin. Kontrollojeni dhe ruajeni.",
  "Tell VERA about it": "Tregojini VERA-s",
  "Paste whatever you have: the call text, emails, notes, ideas. Or just talk, and VERA writes it down. She fills in the form below; you check it and save.": "Ngjitni çfarëdo që keni: tekstin e thirrjes, emailet, shënimet, idetë. Ose thjesht flisni, dhe VERA e shkruan. Ajo plotëson formularin më poshtë; ju e kontrolloni dhe e ruani.",
  "For example: the new Erasmus+ youth call, deadline 15 March, about 250,000 euros. We want to do it with a partner from Albania on digital skills…": "Për shembull: thirrja e re e Erasmus+ për të rinjtë, afati 15 mars, rreth 250,000 euro. Duam ta bëjmë me një partner nga Shqipëria për aftësitë digjitale…",
  "VERA is reading…": "VERA po lexon…",
  "Fill it in with VERA": "Plotësoje me VERA-n",
  "Stop dictating": "Ndalo diktimin",
  "Dictate": "Dikto",
  "Terms for": "Kushtet për",
  "VERANeural monthly fee (USD)": "Tarifa mujore e VERANeural (USD)",
  "The company's own Azure resource groups, comma separated": "Grupet e burimeve Azure të vetë kompanisë, të ndara me presje",
  "e.g. vera-marine": "p.sh. vera-marine",
  "Outside services, one per line: name | monthly amount | note": "Shërbime të jashtme, një për rresht: emri | shuma mujore | shënim",
  "Meta developer account | 99 | glasses": "Llogari zhvilluesi Meta | 99 | syze",
  "Save terms": "Ruaj kushtet",
  "Costs per project": "Kostot për projekt",
  "Each company pays its own Azure resources, its use of VERA's engine and its outside services at cost, plus VERANeural's fee. Open a project to see what the company sees and set its terms.": "Çdo kompani paguan burimet e veta Azure, përdorimin e motorit të VERA-s dhe shërbimet e jashtme me kosto, plus tarifën e VERANeural. Hapni një projekt për të parë çfarë sheh kompania dhe për të caktuar kushtet e saj.",
  "Project": "Projekt",
  "Own Azure": "Azure i vet",
  "Outside": "Të jashtme",
  "VERANeural fee": "Tarifa e VERANeural",
  "Company pays": "Kompania paguan",
  "VERANeural's own Azure": "Azure i VERANeural",
  "Groups no company owns:": "Grupe që nuk i takojnë asnjë kompanie:",
  "· what they see": "· çfarë shohin",
  "(US) or call": "(SHBA) ose telefononi",
  "(US) or": "(SHBA) ose",
  "(Europe).": "(Evropë).",
  "VERA {version} is ready. It also installs by itself the next time you close VERA.": "VERA {version} është gati. Instalohet edhe vetë herën tjetër që e mbyllni VERA-n.",
  "Restarting…": "Po rinis…",
  "Restart to update to {version}": "Rinis për ta përditësuar në {version}",
  "Something went wrong.": "Diçka shkoi keq.",
  "Your company's name": "Emri i kompanisë suaj",
  "Your people see it in Studio and in the staff app, and VERA works for your company by this name.": "Njerëzit tuaj e shohin në Studio dhe në aplikacionin e stafit, dhe VERA punon për kompaninë tuaj me këtë emër.",
  "Company name": "Emri i kompanisë",
  "Product name (optional)": "Emri i produktit (opsional)",
  "Emails from the staff app": "Emailet nga aplikacioni i stafit",
  "VERA writes to these managers when staff report something and say yes. Emails to clients wait here for you to check and send.": "VERA u shkruan këtyre menaxherëve kur stafi raporton diçka dhe thotë po. Emailet për klientët presin këtu që t'i kontrolloni dhe dërgoni.",
  "Managers' email addresses, separated by commas": "Adresat email të menaxherëve, të ndara me presje",
  "To": "Për",
  "To the managers": "Për menaxherët",
  "Open in email": "Hap në email",
  "Copied": "U kopjua",
  "Copy": "Kopjo",
  "Dismiss": "Mbyll",
  "Staff app": "Aplikacioni i stafit",
  "Give access to the staff app": "Jep qasje në aplikacionin e stafit",
  "QR code of the staff app's link": "Kodi QR i lidhjes së aplikacionit të stafit",
  "Code": "Kodi",
  "In use: they have set their PIN.": "Në përdorim: e kanë vendosur PIN-in.",
  "Not used yet: they set a PIN at their first sign-in. The code expires after 14 days unused.": "Ende i papërdorur: PIN-i vendoset në hyrjen e parë. Kodi skadon pas 14 ditësh pa përdorim.",
  "They scan the QR code or open": "Ata skanojnë kodin QR ose hapin",
  "the link": "lidhjen",
  ", sign in with the code, and add the app to their home screen.": ", hyjnë me kodin dhe e shtojnë aplikacionin në ekranin kryesor.",
  "New PIN": "PIN i ri",
  "Switch off this code? The person is signed out of the staff app at once.": "Ta çaktivizoj këtë kod? Personi del menjëherë nga aplikacioni i stafit.",
  "Switch off": "Çaktivizo",
  "Scan with the phone's camera": "Skano me kamerën e telefonit",
  "QR code": "Kodi QR",
  "QR code of this checkpoint": "Kodi QR i kësaj pike kontrolli",
  "Print it and put it up at this place. Staff scan it with the phone's camera: the check lands here, and a problem goes to Issues.": "Printojeni dhe vendoseni në këtë vend. Stafi e skanon me kamerën e telefonit: kontrolli regjistrohet këtu, dhe një problem shkon te Problemet.",
  "Download to print": "Shkarko për printim",
  "Make QR code": "Krijo kodin QR",
  "name@company.com": "emri@kompania.com",
  "VERA needs your permission to use the microphone. On Windows, open Settings, then Privacy & security, then Microphone, and allow desktop apps.": "VERA ka nevojë për lejen tuaj për mikrofonin. Në Windows hapni Cilësimet, pastaj Privatësia dhe siguria, pastaj Mikrofoni, dhe lejoni aplikacionet desktop.",
  "Sample mode: the orb follows your voice so you can feel it. Nothing is recorded or sent. VERA's real-time voice from Azure AI Foundry connects here once the control plane is linked.": "Mënyra shembull: sfera ndjek zërin tuaj që ta ndieni. Asgjë nuk regjistrohet ose dërgohet. Zëri i VERA-s në kohë reale nga Azure AI Foundry lidhet këtu sapo të lidhet kontrolli.",
  "You": "Ju",
  "Unmute": "Aktivizo zërin",
  "Mute": "Hesht",
  "Cc": "Cc",
  "(Excel)": "(Excel)",
  "Teams meeting": "Takim në Teams",
  "Couldn't load photos from the field.": "Fotot nga terreni nuk u ngarkuan.",
  "Photos from VERA Field appear here with live VERA.": "Fotot nga VERA Field shfaqen këtu me VERA-n live.",
  "Your role doesn't include a workspace with field photos.": "Roli juaj nuk përfshin një hapësirë pune me foto nga terreni.",
  "What people showed VERA through their glasses, with her note. Deleted automatically after 12 months.": "Çfarë i treguan njerëzit VERA-s përmes syzeve, me shënimin e saj. Fshihen automatikisht pas 12 muajsh.",
  "Refresh": "Rifresko",
  "No photos from the field in": "Ende pa foto nga terreni në",
  "yet. They appear here when someone says \"VERA, look\" in VERA Field.": ". Shfaqen këtu kur dikush thotë \"VERA, shiko\" në VERA Field.",
  "Someone on the team": "Dikush nga ekipi",
  "VERA's note:": "Shënimi i VERA-s:",
  "Ask VERA about this": "Pyete VERA-n për këtë",
  "This workbook has no Action Log or Milestones sheet that VERA recognises.": "Ky libër nuk ka fletë Action Log ose Milestones që VERA i njeh.",
  "VERA couldn't read that file. Please choose an Excel workbook (.xlsx).": "VERA nuk e lexoi dot atë skedar. Ju lutem zgjidhni një libër Excel (.xlsx).",
  "Plan \"{title}\" created in {group}.": "Plani \"{title}\" u krijua në {group}.",
  "{n} tasks created in {plan}.": "{n} detyra u krijuan në {plan}.",
  "created in": "u krijua në",
  "Not created:": "Nuk u krijuan:",
  "1. Workbook": "1. Libri",
  "Choose another": "Zgjidh një tjetër",
  "Choose Excel file": "Zgjidh skedarin Excel",
  "2. Sheet": "2. Fleta",
  ". Planner plan": ". Plani në Planner",
  "Choose a plan": "Zgjidh një plan",
  "No plans yet: create one below": "Ende pa plane: krijoni një më poshtë",
  "+ Create a new plan…": "+ Krijo një plan të ri…",
  "New plan": "Plan i ri",
  "VERA Operating": "VERA Operating",
  "Plan name": "Emri i planit",
  "Team": "Ekipi",
  "Loading your teams…": "Po ngarkohen ekipet tuaja…",
  "No teams found": "Nuk u gjetën ekipe",
  "In:": "Në:",
  "Create plan": "Krijo planin",
  "Buckets (Planner's columns)": "Kova (kolonat e Planner)",
  "By Source / Forum": "Sipas burimit / forumit",
  "By Workstream": "Sipas rrjedhës së punës",
  "By Milestone": "Sipas pikës kryesore",
  "One bucket": "Një kovë",
  "Reading the workbook…": "Po lexohet libri…",
  "Checking the plan…": "Po kontrollohet plani…",
  "Card": "Karta",
  "Bucket": "Kova",
  "Assigned": "Caktuar",
  "Dates": "Datat",
  "Progress": "Progresi",
  "Priority": "Përparësia",
  "Sent": "Dërguar",
  "Send {what}": "Dërgo {what}",
  "Not a member of this plan's group, so Planner can't assign them. Their name goes in the notes.": "Nuk është anëtar i grupit të këtij plani, ndaj Planner nuk mund ta caktojë. Emri shkon te shënimet.",
  "(not in plan)": "(jo në plan)",
  "Everything else (support, dependencies, latest update, evidence, acceptance criteria) goes into each card's notes. Rows already in the plan show \"Sent\" and are skipped.": "Gjithçka tjetër (mbështetja, varësitë, përditësimi i fundit, dëshmitë, kriteret e pranimit) shkon te shënimet e çdo karte. Rreshtat që janë tashmë në plan shfaqin \"Dërguar\" dhe anashkalohen.",
  "1 card to create. Windows asks you to confirm.": "1 kartë për t'u krijuar. Windows ju kërkon konfirmim.",
  "{n} cards to create. Windows asks you to confirm.": "{n} karta për t'u krijuar. Windows ju kërkon konfirmim.",
  "Choose the workbook and a plan to see the preview.": "Zgjidhni librin dhe një plan për të parë parapamjen.",
  "Creating cards…": "Po krijohen kartat…",
  "Send {n} to Planner": "Dërgo {n} te Planner",
  "GitHub connected. Read only.": "GitHub u lidh. Vetëm lexim.",
  "Azure connected. Read only, for what your Azure role allows.": "Azure u lidh. Vetëm lexim, aq sa lejon roli juaj në Azure.",
  "For the VERANeural team": "Për ekipin e VERANeural",
  "Connected": "E lidhur",
  "Not connected": "E palidhur",
  "Setup needed": "Duhet konfigurim",
  "Desktop sign-in": "Hyrje në desktop",
  "Eva finishes the setup for this, then it appears here.": "Eva e përfundon konfigurimin për këtë, pastaj shfaqet këtu.",
  "Available in VERA for desktop with Microsoft sign-in.": "E disponueshme në VERA për desktop me hyrje Microsoft.",
  "Disconnect": "Shkëput",
  "Waiting…": "Në pritje…",
  "Connect": "Lidh",
  "Connect GitHub": "Lidh GitHub",
  "GitHub opened in your browser. Enter this code there and click": "GitHub u hap në shfletuesin tuaj. Shkruani atje këtë kod dhe klikoni",
  "Authorize": "Autorizo",
  "Code copied.": "Kodi u kopjua.",
  "Copy code": "Kopjo kodin",
  "Open GitHub again": "Hap GitHub përsëri",
  "VERA waits here and continues as soon as you've approved.": "VERA pret këtu dhe vazhdon sapo të keni miratuar.",
  "Couldn't load requests.": "Kërkesat nuk u ngarkuan.",
  "Reopened.": "U rihap.",
  "Marked done.": "U shënua si e kryer.",
  "Declined.": "U refuzua.",
  "Couldn't update the request.": "Kërkesa nuk u përditësua.",
  "Requests from the team": "Kërkesat nga ekipi",
  "What people asked to have turned on. They're also emailed to you.": "Çfarë kërkuan njerëzit të aktivizohet. Ju dërgohen edhe me email.",
  "Hide closed": "Fshih të mbyllurat",
  "Closed ({n})": "Të mbyllura ({n})",
  "No open requests.": "Asnjë kërkesë e hapur.",
  "Open": "Hap",
  "Declined": "Refuzuar",
  " · closed by {who}": " · mbyllur nga {who}",
  "Decline": "Refuzo",
  "Reopen": "Rihap",
  "Sent to Eva. She also sees it in Studio under Requests from the team.": "U dërgua te Eva. Ajo e sheh edhe në Studio te Kërkesat nga ekipi.",
  "Sent to Eva.": "U dërgua te Eva.",
  "Your request is with Eva. She sees it in Studio under Requests from the team.": "Kërkesa juaj është te Eva. Ajo e sheh në Studio te Kërkesat nga ekipi.",
  "Request copied. Paste it into an email or Teams message to Eva.": "Kërkesa u kopjua. Ngjiteni në një email ose mesazh Teams për Evën.",
  "Ask Eva to turn this on for you.": "Kërkojini Evës ta aktivizojë këtë për ju.",
  "For:": "Për:",
  "Build status": "Gjendja e ndërtimit",
  "Engine plan": "Plani i motorit",
  "VERA + Azure or VERA Frontier: runs in VERANeural's own Azure.": "VERA + Azure ose VERA Frontier: punon në Azure-in e VERANeural.",
  "VERA Frontier only: an outside service under contract, never used for training, every call logged.": "Vetëm VERA Frontier: një shërbim i jashtëm me kontratë, që nuk përdoret kurrë për trajnim, çdo thirrje regjistrohet.",
  "Guardrails": "Mbrojtjet",
  "sk-…": "sk-…",
  "Switch off this portal link? It stops working at once.": "Ta çaktivizoj këtë lidhje portali? Ndalon së punuari menjëherë.",
  "Owner portal": "Portali i klientit",
  "A private page for this client: their projects, milestones, the reports, documents and designs you share with them, and the decisions waiting for them. No account needed.": "Një faqe private për këtë klient: projektet, pikat kryesore, raportet, dokumentet dhe projektimet që ndani me të, dhe vendimet që e presin. Pa llogari.",
  "Here is the link. Copy it now: it is shown only once.": "Ja lidhja. Kopjojeni tani: shfaqet vetëm një herë.",
  "Active link": "Lidhje aktive",
  "made by": "krijuar nga",
  "Make a new link": "Krijo një lidhje të re",
  "Make a portal link": "Krijo lidhje portali",
  "That didn't work. Please try again.": "Nuk funksionoi. Ju lutem provoni përsëri.",
  "VERA Brain": "Truri i VERA-s",
  "Counted from your records, live": "Llogaritur drejtpërdrejt nga të dhënat tuaja",
  "Your workspace is empty. Start from a demo firm with realistic projects, then make it yours.": "Hapësira juaj e punës është bosh. Nisni nga një firmë demo me projekte realiste, pastaj bëjeni tuajën.",
  "The demo firm has new records you don't have yet.": "Firma demo ka të dhëna të reja që ju ende nuk i keni.",
  "Load the demo firm": "Ngarko firmën demo",
  "Add the new demo records": "Shto të dhënat e reja demo",
  "Intelligence layers": "Shtresat e inteligjencës",
  "What do you see on the layer:": "Çfarë sheh në shtresën:",
  "Win": "Fito",
  "Funding found early, the right calls chosen, proposals that score.": "Financim i gjetur herët, thirrjet e duhura të zgjedhura, propozime që marrin pikë.",
  "Deliver": "Realizo",
  "Every deadline, deliverable, report and invoice on time.": "Çdo afat, rezultat, raport dhe faturë në kohë.",
  "Impact": "Ndikimi",
  "What the work changes: people trained, evaluations done, evidence that lasts.": "Çfarë ndryshon puna: njerëz të trajnuar, vlerësime të kryera, dëshmi që mbeten.",
  "Clients & consortia": "Klientët dhe konsorciumet",
  "Universities, schools, municipalities, NGOs and partners, and who has worked with whom.": "Universitete, shkolla, komuna, OJQ dhe partnerë, dhe kush ka punuar me kë.",
  "Funding intelligence": "Inteligjenca e financimit",
  "Open calls from the EU, UN agencies, donors and governments: eligibility, fit, amount and deadline.": "Thirrje të hapura nga BE-ja, agjencitë e OKB-së, donatorët dhe qeveritë: pranueshmëria, përshtatja, shuma dhe afati.",
  "Documents & evidence": "Dokumentet dhe dëshmitë",
  "Past proposals, CVs, letters of support, statistics and studies, searchable in plain words.": "Propozime të mëparshme, CV, letra mbështetjeje, statistika dhe studime, të kërkueshme me fjalë të thjeshta.",
  "Finance & budgets": "Financat dhe buxhetet",
  "Eligible costs, co-financing, budgets and invoices.": "Kostot e pranueshme, bashkëfinancimi, buxhetet dhe faturat.",
  "Proposal workflow": "Rrjedha e propozimit",
  "From go or no-go to the evaluator's pass and submission, step by step.": "Nga vendimi po ose jo deri te kontrolli si vlerësues dhe dorëzimi, hap pas hapi.",
  "Communication": "Komunikimi",
  "Partner emails, calls and meetings turned into decisions and next steps.": "Emailet, thirrjet dhe takimet me partnerët kthehen në vendime dhe hapa të ardhshëm.",
  "Schedule & capacity": "Orari dhe kapaciteti",
  "Projects, deadlines and who has the time to write, teach and evaluate.": "Projektet, afatet dhe kush ka kohë për të shkruar, mësuar dhe vlerësuar.",
  "Delivery in the field": "Realizimi në terren",
  "Trainings, workshops and site visits, and what they reached.": "Trajnimet, punëtoritë dhe vizitat në terren, dhe çfarë arritën.",
  "Compliance & quality": "Përputhshmëria dhe cilësia",
  "Evaluations, accreditation standards, EU financial rules and reporting duties.": "Vlerësimet, standardet e akreditimit, rregullat financiare të BE-së dhe detyrimet e raportimit.",
  "Decision & predictive": "Vendimi dhe parashikimi",
  "Which calls to chase, the chance of winning, and where a project will slip.": "Cilat thirrje t'i ndiqni, gjasat për të fituar dhe ku do të vonohet një projekt.",
  "Institutional memory": "Kujtesa institucionale",
  "What won, what evaluators said, and what one project teaches the next.": "Çfarë fitoi, çfarë thanë vlerësuesit dhe çfarë i mëson një projekt tjetrit.",
  "Calls closing within 14 days": "Thirrje që mbyllen brenda 14 ditëve",
  "Applications in preparation": "Aplikime në përgatitje",
  "Value in the pipeline": "Vlera në proces",
  "Applications won": "Aplikime të fituara",
  "Applications due within 7 days": "Aplikime me afat brenda 7 ditëve",
  "Evaluations past due": "Vlerësime me afat të kaluar",
  "Invoices overdue": "Fatura me vonesë",
  "Projects in reporting": "Projekte në raportim",
  "Trainings held": "Trajnime të mbajtura",
  "People trained": "Njerëz të trajnuar",
  "Evaluations completed": "Vlerësime të përfunduara",
  "Welcome, {name}. Here's how VERA works with you.": "Mirë se erdhe, {name}. Ja si punon VERA me ty.",
  "Ask VERA about {what}, type / for commands, or drop files here": "Pyete VERA-n për {what}, shkruaj / për komanda, ose lësho skedarë këtu",
  "From the tracker, email and VERA": "Nga lista e punëve, emaili dhe VERA",
  "Paste the call text (Edit) so VERA works from the real rules, not assumptions.": "Ngjit tekstin e thirrjes (Ndrysho), që VERA të punojë me rregullat e vërteta dhe jo me supozime.",
  "Run the proposal pipeline: VERA reads the call, you decide go or no-go, then she drafts, builds the budget, scores it as an EU evaluator would, and makes the Word and PDF.": "Nis rrjedhën e propozimit: VERA lexon thirrjen, ti vendos po ose jo, pastaj ajo harton, bën buxhetin, e vlerëson si vlerësues i BE-së, dhe në fund krijon Word dhe PDF.",
  "Connect Teams": "Lidh Teams",
  "Couldn't open that email.": "Ky email nuk u hap.",
  "The deadline is in your calendar.": "Afati u shtua në kalendar.",
  "The connection to VERA dropped.": "Lidhja me VERA-n u ndërpre.",
  "See the result": "Shiko rezultatin",
  "VERANeural HQ": "VERANeural HQ",
  "Shape VERANeural HQ in plain words": "Formëso VERANeural HQ me fjalët e tua",
  "Say what the team needs and VERA builds it: lists, fields, choices and items. She shows you each change before it happens.": "Thuaj çfarë i duhet ekipit dhe VERA e ndërton: lista, fusha, zgjedhje dhe artikuj. Ajo të tregon çdo ndryshim para se të ndodhë.",
  "Tell VERA how your workspace should work: new lists, fields, choices, names, or who sees what. Attach a paper form or a photo and she'll set it up from that. You'll see the change before it happens, and you can undo it.": "Thuaji VERA-s si duhet të punojë hapësira jote: lista të reja, fusha, zgjedhje, emra ose kush sheh çfarë. Bashkëngjit një formular ose një foto dhe ajo e përgatit sipas tij. E sheh ndryshimin para se të ndodhë dhe mund ta zhbësh.",
  // On the road: the field bar (FieldBar).
  "Sent to the job.": "U dërgua te puna.",
  "sent to their jobs.": "u dërguan te punët e tyre.",
  "Sending…": "Po dërgohet…",
  "Saved on your phone. It goes when you have signal.": "U ruajt në telefon. Dërgohet kur të keni sinjal.",
  "On the road": "Në rrugë",
  "Today": "Sot",
  "Talk": "Fol",
  "Snap": "Foto",
  "Attach": "Bashkëngjit",
  "larger than 100 MB": "më e madhe se 100 MB",
  "Uploaded from the phone": "Ngarkuar nga telefoni",
  "saved to From the field.": "u ruajt te «Nga terreni».",
  "Not uploaded:": "Nuk u ngarkua:",
  "Note": "Shënim",
  "waiting": "në pritje",
  "That photo couldn't be read. Try again.": "Kjo foto nuk u lexua dot. Provoni përsëri.",
  "File the photo": "Ruaje foton",
  "Add a note": "Shto një shënim",
  "File the photo on a job": "Ruaje foton te një punë",
  "Add a note to a job": "Shto një shënim te një punë",
  "Job": "Puna",
  "Choose the job…": "Zgjidh punën…",
  "Caption (optional)": "Përshkrim (opsional)",
  "What it shows": "Çfarë tregon",
  "What you saw, measured or need: materials, next steps": "Çfarë patë, matët ose ju duhet: materiale, hapat e ardhshëm",
  // Build → Help (HelpPane).
  // Help → Tell VERA (Requests, phase 1).
  "Add a screenshot": "Shto një pamje ekrani",
  "All right. Nothing was done, and it's kept if you need it later.": "Në rregull. Nuk u bë asgjë, dhe ruhet nëse ju duhet më vonë.",
  "Approve": "Mirato",
  "Ask something else": "Pyet diçka tjetër",
  "Change something": "Ndrysho diçka",
  "Close Help": "Mbyll Ndihmën",
  "One moment…": "Një moment…",
  "Only this summary. Your own words, screenshots and data stay in your workspace.": "Vetëm kjo përmbledhje. Fjalët tuaja, pamjet e ekranit dhe të dhënat mbeten në hapësirën tuaj të punës.",
  "Read it again": "Lexoje përsëri",
  "Send as written": "Dërgoje siç është shkruar",
  "Send to VERA": "Dërgo te VERA",
  "Send to support as written": "Dërgoje te mbështetja siç është shkruar",
  "Sent to the VERANeural team, as you approved it. VERA follows it and tells you what happens.": "U dërgua te ekipi i VERANeural, siç e miratuat. VERA e ndjek dhe ju tregon çfarë ndodh.",
  "That didn't go through. Nothing changed.": "Nuk u krye. Asgjë nuk ndryshoi.",
  "That helps": "Kjo ndihmon",
  "The answer": "Përgjigjja",
  "This change is made in VERA Build by a workspace owner. VERA has kept your request for them.": "Ky ndryshim bëhet në VERA Build nga një pronar i hapësirës së punës. VERA e ka ruajtur kërkesën tuaj për ta.",
  "VERA Build is planning it now. You'll see the change before anything happens.": "VERA Build po e planifikon tani. Do ta shihni ndryshimin para se të ndodhë diçka.",
  "VERA couldn't read it just now. You can send it to the VERANeural team exactly as you wrote it, or try again in a minute.": "VERA nuk e lexoi dot tani. Mund ta dërgoni te ekipi i VERANeural pikërisht siç e shkruat, ose provoni përsëri pas një minute.",
  "VERA couldn't read it just now.": "VERA nuk e lexoi dot tani.",
  "VERA is looking at your screenshot…": "VERA po shikon pamjen tuaj të ekranit…",
  "VERA is reading it again…": "VERA po e lexon përsëri…",
  "VERA is reading it…": "VERA po e lexon…",
  "What I understood": "Çfarë kuptova",
  "What I'll do": "Çfarë do të bëj",
  "What changes for you": "Çfarë ndryshon për ju",
  "What goes to the VERANeural team": "Çfarë shkon te ekipi i VERANeural",
  "What should be different?": "Çfarë duhet të jetë ndryshe?",
  "Write it once. VERA reads it, tells you what she understood and what she'll do, and nothing happens until you say yes.": "Shkruajeni një herë. VERA e lexon, ju tregon çfarë kuptoi dhe çfarë do të bëjë, dhe asgjë nuk ndodh derisa të thoni po.",
  "Your email for the answer": "Email-i juaj për përgjigjen",
  "(VERA couldn't read this screenshot.)": "(VERA nuk e lexoi dot këtë pamje ekrani.)",
  "Help": "Ndihmë",
  "Back to Build": "Kthehu te Build",
  "Quick fixes": "Zgjidhje të shpejta",
  "Tell us": "Na shkruani",
  "It goes straight to the VERANeural team with what you were looking at. No meeting needed; we answer by email.": "Shkon drejt te ekipi i VERANeural, bashkë me atë që po shikonit. Nuk duhet takim; përgjigjemi me email.",
  "Sent. The VERANeural team has it and will get back to you.": "U dërgua. Ekipi i VERANeural e ka marrë dhe do t'ju përgjigjet.",
  "Send another": "Dërgo një tjetër",
  "What is it?": "Për çfarë bëhet fjalë?",
  "What happened, or what you need": "Çfarë ndodhi, ose çfarë ju duhet",
  "Your email for the answer (optional)": "Email-i juaj për përgjigjen (opsional)",
  "It didn't go through. Try again in a minute.": "Nuk u dërgua. Provoni përsëri pas një minute.",
  "Send to support": "Dërgo te mbështetja",
  "Something's wrong": "Diçka nuk shkon",
  "A question": "Një pyetje",
  "An idea": "Një ide",
  "What happened, and what you expected instead": "Çfarë ndodhi, dhe çfarë prisnit në vend të saj",
  "What would make Studio better for you": "Çfarë do ta bënte Studio më të mirë për ju",
  "What you'd like to know": "Çfarë dëshironi të dini",
  "VERA doesn't answer, or says she's unavailable": "VERA nuk përgjigjet, ose thotë që nuk është e disponueshme",
  "Check your signal, then close Studio and open it again. If it keeps happening, sign out and back in from your name at the top.": "Kontrolloni sinjalin, pastaj mbylleni Studio dhe hapeni përsëri. Nëse vazhdon, dilni dhe hyni përsëri nga emri juaj lart.",
  "The phone app asks me to sign in again": "Aplikacioni në telefon më kërkon të hyj përsëri",
  "Open Studio from the icon on your home screen and sign in once. It remembers you after that.": "Hapeni Studio nga ikona në ekranin kryesor dhe hyni një herë. Pas kësaj ju mban mend.",
  "Talk or Dictate doesn't hear me": "Fol ose Diktimi nuk më dëgjon",
  "Turn on the microphone in Privacy. On iPhone also open Settings, then Safari, then Microphone, and choose Allow.": "Ndizni mikrofonin te Privatësia. Në iPhone hapni edhe Settings, pastaj Safari, pastaj Microphone, dhe zgjidhni Allow.",
  "A photo or note hasn't arrived": "Një foto ose shënim nuk ka arritur",
  "It's saved on your phone and goes on its own when you have signal. Until then it shows as waiting at the bottom.": "Është ruajtur në telefon dhe dërgohet vetë kur të keni sinjal. Deri atëherë shfaqet poshtë si në pritje.",
  "VERA on WhatsApp doesn't reply": "VERA në WhatsApp nuk përgjigjet",
  "Write from the phone number VERA knows you by. If there's still no answer after a minute, send it below as a problem.": "Shkruani nga numri i telefonit me të cilin ju njeh VERA. Nëse pas një minute ende s'ka përgjigje, dërgojeni më poshtë si problem.",
  "My email or calendar isn't showing": "Email-i ose kalendari im nuk shfaqet",
  "Open Connections and connect Microsoft 365 or Google again. It takes a minute.": "Hapni Lidhjet dhe lidhni përsëri Microsoft 365 ose Google. Zgjat një minutë.",
  "Something changed that I didn't want": "Ndryshoi diçka që nuk e doja",
  "Every change is in Activity, and changes made in Build can be undone there or here.": "Çdo ndryshim është te Aktiviteti, dhe ndryshimet e bëra në Build mund të zhbëhen atje ose këtu.",
  // Owners' Home: company, safety and the law (SafetyCard).
  "Your company, safety and the law": "Kompania juaj, siguria dhe ligji",
  "Your name on VERA": "Emri juaj në VERA",
  "Your people see your company's name, and your own product name if you give one, in Studio and the staff app. A fully licensed copy under your own brand and web address is available from VERANeural.": "Njerëzit tuaj shohin emrin e kompanisë suaj, dhe emrin e produktit tuaj nëse e jepni, në Studio dhe në aplikacionin e stafit. Një kopje plotësisht e licencuar me markën dhe adresën tuaj në internet ofrohet nga VERANeural.",
  "Privacy": "Privatësia",
  "Security": "Siguria",
  "Recording conversations": "Regjistrimi i bisedave",
  "Who is responsible": "Kush është përgjegjës",
  "The laws that matter for your work": "Ligjet që kanë rëndësi për punën tuaj",
  "Your records, notes, photos and conversations stay in your company's own space on VERANeural's Microsoft Azure servers in the United States. Other companies on VERA never see them.": "Të dhënat, shënimet, fotot dhe bisedat tuaja qëndrojnë në hapësirën e kompanisë suaj në serverët Microsoft Azure të VERANeural në Shtetet e Bashkuara. Kompanitë e tjera në VERA nuk i shohin kurrë.",
  "VERA reads your email and calendar only after you connect them, with your own sign-in, and sees only what you can see.": "VERA lexon email-in dhe kalendarin tuaj vetëm pasi t'i lidhni me hyrjen tuaj, dhe sheh vetëm atë që shihni ju.",
  "Nothing you put in VERA is used to train AI models.": "Asgjë që vendosni në VERA nuk përdoret për të trajnuar modele të AI-së.",
  "To get a copy of your data, or to have it deleted, write to support@veraneural.com.": "Për një kopje të të dhënave tuaja, ose për t'i fshirë, shkruani te support@veraneural.com.",
  "Everyone signs in with their own work account. Each person sees only what their role allows.": "Secili hyn me llogarinë e vet të punës. Secili sheh vetëm atë që lejon roli i tij.",
  "Keys for connected apps are kept in a secure vault on VERANeural's servers, never in the app or on your phone.": "Çelësat e aplikacioneve të lidhura ruhen në një kasafortë të sigurt në serverët e VERANeural, kurrë në aplikacion apo në telefonin tuaj.",
  "Everything is encrypted on the way and where it's stored.": "Gjithçka është e enkriptuar gjatë rrugës dhe aty ku ruhet.",
  "Every change VERA or your team makes is in Activity, with who made it, and can be undone.": "Çdo ndryshim që bën VERA ose ekipi juaj është te Aktiviteti, me emrin e kujt e bëri, dhe mund të zhbëhet.",
  "Before you record a phone call or a conversation in person, everyone in it must agree. Say it at the start: \"I'm recording this so I don't miss anything. Is that OK?\" If someone says no, take notes instead.": "Para se të regjistroni një telefonatë ose një bisedë ballë për ballë, të gjithë pjesëmarrësit duhet të pajtohen. Thuajeni në fillim: \"Po e regjistroj që të mos më shpëtojë asgjë. A është në rregull?\" Nëse dikush thotë jo, mbani shënime.",
  "VERA never records a call by herself. Talk with VERA hears only you, while the Talk screen is open.": "VERA nuk regjistron kurrë vetë një telefonatë. Fol me VERA-n ju dëgjon vetëm juve, sa kohë që ekrani Fol është i hapur.",
  "A voice note you send VERA on WhatsApp becomes text; VERA keeps the words, not the audio. Send only recordings the people in them agreed to.": "Një mesazh zanor që i dërgoni VERA-s në WhatsApp bëhet tekst; VERA ruan fjalët, jo audion. Dërgoni vetëm regjistrime për të cilat njerëzit në to kanë dhënë pëlqimin.",
  "VERA helps you work; she doesn't replace your judgement. She can make mistakes. Check anything important before you rely on it: prices, quotes, weather, tides, directions, and anything legal or about safety.": "VERA ju ndihmon në punë; nuk e zëvendëson gjykimin tuaj. Mund të gabojë. Kontrolloni çdo gjë të rëndësishme para se të mbështeteni tek ajo: çmimet, ofertat, motin, baticat, drejtimet, dhe çdo gjë ligjore ose për sigurinë.",
  "Your company stays responsible for its work, its people, the boats it works on, and what it sends to customers.": "Kompania juaj mbetet përgjegjëse për punën, njerëzit, varkat në të cilat punon, dhe atë që u dërgon klientëve.",
  "VERANeural is not responsible for decisions made from VERA's suggestions, except as set out in your agreement with VERANeural.": "VERANeural nuk është përgjegjëse për vendimet e marra nga sugjerimet e VERA-s, përveç siç përcaktohet në marrëveshjen tuaj me VERANeural.",
  "Florida's Security of Communications Act (Chapter 934): recording a call or private conversation needs the consent of everyone in it.": "Ligji i Floridës për Sigurinë e Komunikimeve (Kapitulli 934): regjistrimi i një telefonate ose bisede private kërkon pëlqimin e të gjithë pjesëmarrësve.",
  "Florida Information Protection Act (section 501.171): if customers' personal information may have been exposed, they must be told. Tell VERANeural straight away and we help.": "Ligji i Floridës për Mbrojtjen e Informacionit (neni 501.171): nëse të dhënat personale të klientëve mund të jenë ekspozuar, ata duhet të njoftohen. Njoftoni menjëherë VERANeural dhe ne ndihmojmë.",
  "CAN-SPAM Act: marketing emails need your company's real address and an easy way to unsubscribe.": "Ligji CAN-SPAM: email-et e marketingut duhet të kenë adresën e vërtetë të kompanisë dhe një mënyrë të lehtë për t'u çabonuar.",
  "Telephone Consumer Protection Act: marketing texts and automated calls need the customer's written consent first.": "Ligji për Mbrojtjen e Konsumatorit në Telefon: mesazhet e marketingut dhe thirrjet e automatizuara kërkojnë më parë pëlqimin me shkrim të klientit.",
  "Weather and tides in VERA come from NOAA and the National Weather Service. Before going out, check the official forecast and U.S. Coast Guard notices.": "Moti dhe baticat në VERA vijnë nga NOAA dhe Shërbimi Kombëtar i Motit. Para se të dilni, kontrolloni parashikimin zyrtar dhe njoftimet e Rojes Bregdetare të SHBA-së.",
  "They depend on where your company works. Ask VERANeural at support@veraneural.com for the summary for your country.": "Varen nga vendi ku punon kompania juaj. Kërkojini VERANeural te support@veraneural.com përmbledhjen për vendin tuaj.",
  "A plain-language summary, not legal advice. For your own situation, ask your lawyer.": "Një përmbledhje me fjalë të thjeshta, jo këshillë ligjore. Për rastin tuaj, pyesni avokatin tuaj.",
  // Chat: cancel or move a meeting (ActionCard).
  "Connect Gmail or Outlook in Connections first.": "Lidh më parë Gmail ose Outlook te Lidhjet.",
  "Moved. Everyone invited gets the new time.": "U zhvendos. Të gjithë të ftuarit marrin orën e re.",
  "Done. Everyone invited has been told.": "U krye. Të gjithë të ftuarit u njoftuan.",
  "Move a meeting": "Zhvendos një takim",
  "Cancel a meeting": "Anulo një takim",
  "New time": "Ora e re",
  "Note to the others": "Shënim për të tjerët",
  "Optional": "Opsionale",
  "Move meeting": "Zhvendos takimin",
  "Cancel meeting": "Anulo takimin",
  "Nothing changes until you press the button and confirm.": "Asgjë nuk ndryshon derisa të shtypni butonin dhe ta konfirmoni.",
  // Home: documents inbox and memory (DocumentsInbox, MemoryCard).
  "VERA couldn't read it. Try it again.": "VERA nuk e lexoi dot. Provoni përsëri.",
  "Not added: {list}": "Nuk u shtuan: {list}",
  "Drop it here, VERA files it": "Lëreni këtu, VERA e rendit",
  "Add files": "Shto skedarë",
  "Quotes, invoices, work orders, manuals, inventory lists, photos: as many as you like. VERA reads each one, puts it with the right customer, boat or job, and tells you what she did. Every change is in Activity and can be undone.": "Oferta, fatura, urdhëra pune, manuale, lista inventari, foto: sa të doni. VERA lexon secilin, e vendos te klienti, varka ose puna e duhur, dhe ju tregon çfarë bëri. Çdo ndryshim është te Aktiviteti dhe mund të zhbëhet.",
  "VERA is working through {n}. Keep Studio open until she's done.": "VERA po punon me {n}. Mbajeni Studio të hapur derisa të mbarojë.",
  "VERA is reading and filing it…": "VERA po e lexon dhe po e rendit…",
  "What VERA remembers about you": "Çfarë mban mend VERA për ju",
  "VERA remembers your conversations, in Studio, by voice and on WhatsApp, and keeps a short notebook of what matters to you. Only you see it. Tell her \"remember…\" or \"forget…\", or delete anything here.": "VERA i mban mend bisedat tuaja, në Studio, me zë dhe në WhatsApp, dhe mban një fletore të shkurtër me atë që ka rëndësi për ju. Vetëm ju e shihni. I thoni \"mbaj mend…\" ose \"harro…\", ose fshini çfarëdo këtu.",
  "Nothing yet.": "Ende asgjë.",
  "Forget this": "Harroje",
  // Location (FieldBar, lib/location).
  "Location": "Vendndodhja",
  "Location on": "Vendndodhja ndezur",
  "Location is off. VERA no longer knows where you are.": "Vendndodhja është fikur. VERA nuk e di më ku jeni.",
  "Location is on. VERA knows where you are when you ask her something.": "Vendndodhja është ndezur. VERA e di ku jeni kur i kërkoni diçka.",
  "Your phone didn't share the location. Allow it for this site in your phone's settings, then try again.": "Telefoni nuk e ndau vendndodhjen. Lejojeni për këtë faqe te cilësimet e telefonit, pastaj provoni përsëri.",
  "Your location is shared only when you switch Location on, and only with your questions to VERA. She doesn't track where you go.": "Vendndodhja juaj ndahet vetëm kur ndizni Vendndodhjen, dhe vetëm me pyetjet tuaja për VERA-n. Ajo nuk ndjek se ku shkoni.",
  // Marine demo company (MarineDemoCard).
  "The demo company has records you don't have yet.": "Kompania demo ka të dhëna që ju ende nuk i keni.",
  "This is the demo company. Load its made-up customers, boats, jobs and parts to show VERA Studio.": "Kjo është kompania demo. Ngarkoni klientët, varkat, punët dhe pjesët e saj të sajuara për të treguar VERA Studio.",
  "Load the demo company": "Ngarko kompaninë demo",
  // The calendar card's Day / Week / Month views
  "Day": "Dita",
  "Week": "Java",
  "Month": "Muaji",
  "Calendar view": "Pamja e kalendarit",
  "All day": "Gjithë ditën",
  "Nothing in your calendar this week.": "Asgjë në kalendar këtë javë.",
  "Nothing in your calendar that day.": "Asgjë në kalendar atë ditë.",
  "Paste whatever you have: the call text, emails, notes, ideas. Or just talk, and VERA writes it down. Or add the files below (the call PDF, an earlier proposal, a photo). She fills in the form; you check it and save.": "Ngjit çfarë ke: tekstin e thirrjes, emailet, shënimet, idetë. Ose fol, dhe VERA shkruan. Ose shto skedarët më poshtë (PDF-në e thirrjes, një propozim të mëparshëm, një foto). Ajo plotëson formularin; ti e kontrollon dhe e ruan.",
  "Paste the call text (Edit) or add the call PDF below, so VERA works from the real rules, not assumptions.": "Ngjit tekstin e thirrjes (Ndrysho) ose shto PDF-në e thirrjes më poshtë, që VERA të punojë me rregullat e vërteta dhe jo me supozime.",
  "Everything that happened, by kind: releases, pull requests, health checks, notes and requests, and every change in your workspace. HQ tells you here instead of by email.": "Gjithçka që ndodhi, sipas llojit: publikimet, pull request-et, kontrollet e shëndetit, shënimet dhe kërkesat, dhe çdo ndryshim në hapësirën tuaj. HQ ju njofton këtu në vend të emailit.",
  "new": "e re",
  "Details": "Detajet",
  "All": "Të gjitha",
  "Releases": "Publikimet",
  "Pull requests": "Pull request-et",
  "Health checks": "Kontrollet e shëndetit",
  "Notes & requests": "Shënime dhe kërkesa",
  "Changes": "Ndryshimet",
  "Look at my Home page with me: what needs me today, what's open and what changed?": "Shiko me mua faqen time kryesore: çfarë më pret sot, çfarë është e hapur dhe çfarë ndryshoi?",
  "My Home page": "Faqja ime kryesore",
  "Ask VERA about this page": "Pyet VERA-n për këtë faqe",
  "Settings": "Cilësimet",
  "How your Home looks, the weather's place, the demo company for showing VERA Studio, what VERA remembers and your company's safety.": "Si duket faqja juaj kryesore, vendi për motin, kompania demo për të treguar VERA Studio, çfarë mban mend VERA dhe siguria e kompanisë suaj.",
  "Demo company": "Kompania demo",
  "For showing VERA Studio to others: made-up customers and work, loaded as one import you can undo in Activity.": "Për t'ua treguar VERA Studio të tjerëve: klientë dhe punë të sajuara, të ngarkuara si një import që mund ta zhbësh te Aktiviteti.",
  "The weather is now for": "Moti tani është për",
  "Your browser didn't allow the location. You can allow it in the browser's site settings.": "Shfletuesi nuk e lejoi vendndodhjen. Mund ta lejosh te cilësimet e faqes në shfletues.",
  "Home": "Kreu",
  "Choose what Home shows. A hidden card isn't deleted: switch it back on any time. Your choices follow you to every device.": "Zgjidh çfarë shfaq faqja kryesore. Një kartë e fshehur nuk fshihet përgjithmonë: ndize sërish kur të duash. Zgjedhjet të ndjekin në çdo pajisje.",
  "Weather for": "Moti për",
  "Your home port: a marina, a town or an address": "Porti juaj: një marinë, një qytet ose një adresë",
  "Finding…": "Po kërkoj…",
  "Use this place": "Përdor këtë vend",
  "Clear": "Pastro",
  "Use where this device is when no home port is set": "Përdor vendin e kësaj pajisjeje kur nuk ka port",
  "Use where this device is (asks your browser)": "Përdor vendin e kësaj pajisjeje (e pyet shfletuesin)",
  "Now:": "Tani:",
  "Now: where this device is": "Tani: aty ku është kjo pajisje",
  "No place yet: Home shows the time without the weather.": "Ende pa vend: faqja kryesore tregon orën pa motin.",
  "Compass": "Busulla",
  "Wind from": "Era nga",
  "wind": "era",
  "from": "nga",
  "rain": "shi",
  "Time and weather": "Ora dhe moti",
  "Later": "Më vonë",
  "Turn the compass with your phone": "Rrotullo busullën me telefonin",
  "Set your home port for the weather": "Vendos portin për motin",
  "The weather isn't available right now.": "Moti nuk është i disponueshëm tani.",
  "Operations overview": "Pasqyra e operacioneve",
  "How VERA understands your company": "Si e kupton VERA kompaninë tuaj",
  "The layers VERA organises everything she learns about your company into, with how many of your records each one holds. Open one to talk about it.": "Shtresat ku VERA rendit gjithçka që mëson për kompaninë tuaj, me sa regjistra ka secila. Hap njërën për të folur për të.",
  "new alert": "njoftim i ri",
  "new alerts": "njoftime të reja",
  "in Activity": "te Aktiviteti",
  "What does the weather mean for today's work on the water?": "Çfarë do të thotë moti për punën e sotme në ujë?",
  "Weather": "Moti",
  "past their date": "me afat të kaluar",
  "for today": "për sot",
  "still open": "ende të hapura",
  "Email from": "Email nga",
  "unread emails from your clients": "emaile të palexuara nga klientët tuaj",
  "Summarise the email from": "Përmblidh emailin nga",
  "about": "për",
  "and tell me what they need.": "dhe më thuaj çfarë u duhet.",
  "Summarise the unread emails from my clients and what each one needs.": "Përmblidh emailet e palexuara nga klientët e mi dhe çfarë i duhet secilit.",
  "Client emails": "Emailet e klientëve",
  "change by your team or VERA": "ndryshim nga ekipi ose VERA",
  "changes by your team or VERA": "ndryshime nga ekipi ose VERA",
  "since you last looked": "që kur shikove herën e fundit",
  "Notifications": "Njoftimet",
  "Nothing needs you right now.": "Asgjë nuk të pret tani.",
  "Drop documents": "Lësho dokumente",
  "Weather and compass": "Moti dhe busulla",
  "Next to the time at the top: the weather now and where the wind comes from": "Pranë orës lart: moti tani dhe nga vjen era",
  "Quick catches: what needs you now": "Shpejt: çfarë të pret tani",
  "Your three things": "Tri gjërat e tua",
  "The three things that matter most today": "Tri gjërat më të rëndësishme sot",
  "What VERA noticed": "Çfarë vuri re VERA",
  "What VERA spotted in your day": "Çfarë pa VERA në ditën tënde",
  "Calendar": "Kalendari",
  "Today's meetings and appointments": "Takimet e sotme",
  "Inbox": "Posta",
  "The latest emails": "Emailet e fundit",
  "Teams": "Teams",
  "Teams chats, or proposal deadlines": "Bisedat në Teams, ose afatet e propozimeve",
  "Who's online": "Kush është në linjë",
  "Who on the team has VERA Studio open (founders and executives)": "Kush nga ekipi e ka VERA Studio të hapur (themeluesit dhe drejtuesit)",
  "Your operations in numbers, counted live from your records": "Operacionet tuaja në shifra, të numëruara drejtpërdrejt nga regjistrat",
  "A brief report of what is still open": "Një raport i shkurtër i asaj që është ende e hapur",
  "The last few changes by you, your team or VERA": "Ndryshimet e fundit nga ti, ekipi ose VERA",
  "Your records": "Regjistrat tuaj",
  "Clients, boats, jobs, materials, orders: one tap each": "Klientët, varkat, punët, materialet, porositë: me një prekje",
  "Ready when you are, {name}.": "Jam gati kur të jesh ti, {name}.",
  "Ready when you are.": "Jam gati kur të jesh ti.",
  "Check my email": "Shiko emailin tim",
  "Add a job": "Shto një punë",
  "What's on today?": "Çfarë kam sot?",
  "What needs me?": "Çfarë më pret?",
  "Hide your conversations": "Fshih bisedat",
  "Show your conversations": "Shfaq bisedat",
  "Your conversations (always saved)": "Bisedat e tua (ruhen gjithmonë)",
  "Turn on the microphone for voice in Privacy & consent first.": "Aktivizo më parë mikrofonin për zërin te Privatësia dhe pëlqimi.",
  "Your CRM, shaped by VERA. Click a row to see or change it, or tell VERA: she puts every detail in the right place.": "CRM-ja juaj, e formësuar nga VERA. Kliko një rresht për ta parë ose ndryshuar, ose tregoji VERA-s: ajo e vendos çdo detaj në vendin e duhur.",
  "Talk to VERA about your records": "Fol me VERA-n për regjistrat",
  "Talk to VERA": "Fol me VERA-n",
  "Type to VERA": "Shkruaji VERA-s",
  "Type": "Shkruaj",
  "How complete the details are": "Sa të plota janë detajet",
  "still missing details": "ende pa detaje",
  "most often": "më shpesh",
  "Show all": "Shfaq të gjitha",
  "Show only these": "Shfaq vetëm këto",
  "Help me fill in the missing details on my {list}, one at a time.": "Më ndihmo të plotësoj detajet që mungojnë te {list}, një nga një.",
  "Fill them in with VERA": "Plotësoji me VERA-n",
  "Missing": "Mungon",
  "1 detail missing": "Mungon 1 detaj",
  "{n} details missing": "Mungojnë {n} detaje",
  "Fill them in": "Plotësoji",
  "What's still missing on this {kind}? Ask me for it one by one.": "Çfarë mungon ende te kjo {kind}? Më pyet një nga një.",
  "missing": "mungon",
  "New choice": "Zgjedhje e re",
  "+ New choice…": "+ Zgjedhje e re…",
  "What's missing here?": "Çfarë mungon këtu?",
  "Fill in what you can": "Plotëso çfarë mundesh",
  "Add a field for this": "Shto një fushë për këtë",
  "How do my {list} look?": "Si duken {list}?",
  "Which {list} are missing details?": "Cilave {list} u mungojnë detaje?",
  "Add a new {kind}": "Shto: {kind}",
  "VERA in your records": "VERA në regjistrat tuaj",
  "Continue in Workspace": "Vazhdo te Hapësira e punës",
  "Tell me anything about your work: I'll put every detail in the right place, link it, and add fields or choices when you need new ones.": "Më trego çdo gjë për punën tënde: e vendos çdo detaj në vendin e duhur, e lidh, dhe shtoj fusha ose zgjedhje kur të duhen të reja.",
  "VERA is on it…": "VERA po merret me të…",
  "Tell VERA about this one…": "Tregoji VERA-s për këtë…",
  "Tell VERA about your {list}…": "Tregoji VERA-s për {list}…",
  "Add photos or videos": "Shto foto ose video",
  "Archive": "Arkivo",
  "Archived": "Të arkivuara",
  "Archived. It's under Archived if you need it.": "U arkivua. E gjen te Të arkivuara nëse të duhet.",
  "Ask VERA about this job": "Pyet VERA-n për këtë punë",
  "At {job}": "Te {job}",
  "Back in VERA Field.": "U kthye te VERA Field.",
  "Choose a {kind}": "Zgjidh: {kind}",
  "Connect them in the VERA Field app on your phone": "Lidhi te aplikacioni VERA Field në telefon",
  "Connection": "Lidhja",
  "Delete this for good? It isn't filed on any record. Archive keeps it instead.": "Ta fshij përgjithmonë? Nuk është në asnjë regjistër. Arkivimi e ruan.",
  "Delete": "Fshij",
  "Deleted.": "U fshi.",
  "Digital twin": "Binjaku dixhital",
  "Everything from the field, tied to your records: where you are, the job you're at, photos, videos, notes and inspections. VERA files each one on the right job.": "Gjithçka nga terreni, e lidhur me regjistrat: ku je, puna ku ndodhesh, fotot, videot, shënimet dhe inspektimet. VERA e vendos secilën te puna e duhur.",
  "Everything is sent": "Gjithçka u dërgua",
  "File on a job": "Vendose te një punë",
  "File on a job…": "Vendose te një punë…",
  "Filed on {job}.": "U vendos te {job}.",
  "Inspections": "Inspektimet",
  "Last look {when}": "Pamja e fundit {when}",
  "Location and time": "Vendi dhe ora",
  "Looks like a copy": "Duket si kopje",
  "Meta glasses": "Syzet Meta",
  "Nearest job: {job}, {d}": "Puna më e afërt: {job}, {d}",
  "No notes yet. Tell VERA, and she writes them on the job.": "Ende pa shënime. Tregoji VERA-s dhe ajo i shkruan te puna.",
  "None for this job yet.": "Ende asnjë për këtë punë.",
  "Not seen yet": "Ende pa u parë",
  "Notes": "Shënimet",
  "Nothing archived.": "Asgjë e arkivuar.",
  "Nothing filed on this job yet.": "Ende asgjë te kjo punë.",
  "Nothing here yet. Photos and videos from the glasses and phones appear here.": "Ende asgjë këtu. Fotot dhe videot nga syzet dhe telefonat shfaqen këtu.",
  "Offline": "Pa lidhje",
  "Online": "Në linjë",
  "Open in Records": "Hape te Regjistrat",
  "Photos and notes wait here and go when the signal is back": "Fotot dhe shënimet presin këtu dhe dërgohen kur kthehet sinjali",
  "Photos": "Fotot",
  "Restore": "Ktheje",
  "Set up inspections for my jobs: a list linked to jobs and boats, with what was checked, the result and photos.": "Krijo inspektimet për punët e mia: një listë e lidhur me punët dhe varkat, me çfarë u kontrollua, rezultatin dhe fotot.",
  "Set up inspections with VERA": "Krijo inspektimet me VERA-n",
  "Sum up the day": "Përmblidhe ditën",
  "Summarise the notes on this job in a few lines: what was done, what was found, what's next.": "Përmblidh shënimet e kësaj pune në pak rreshta: çfarë u bë, çfarë u gjet, çfarë vijon.",
  "Summarise with VERA": "Përmblidhe me VERA-n",
  "Tell me where this job stands and what's still needed.": "Më trego ku është kjo punë dhe çfarë duhet ende.",
  "That job has no place for photos yet. Ask VERA to add one.": "Kjo punë ende nuk ka vend për foto. Kërkoji VERA-s ta shtojë.",
  "The job you're at": "Puna ku je",
  "The video couldn't be saved.": "Videoja nuk u ruajt.",
  "This job:": "Kjo punë:",
  "Today in the field": "Sot në terren",
  "Turn on location and VERA opens the job you're at, or choose one.": "Ndiz vendndodhjen dhe VERA hap punën ku je, ose zgjidh një.",
  "Turn on location": "Ndiz vendndodhjen",
  "VERA Field works with live VERA.": "VERA Field punon me VERA-n e vërtetë.",
  "VERA Field": "VERA Field",
  "Video": "Video",
  "Videos": "Videot",
  "What happened in the field today? Sum up the photos, videos, notes and jobs, and what still needs doing.": "Çfarë ndodhi sot në terren? Përmblidh fotot, videot, shënimet dhe punët, dhe çfarë mbetet për t'u bërë.",
  "Which job": "Cila punë",
  "You're not at any open job right now. Choose one to see everything about it.": "Tani nuk je te asnjë punë e hapur. Zgjidh një për të parë gjithçka për të.",
  "everything about the job, in one place": "gjithçka për punën, në një vend",
  "located": "me vendndodhje",
  "videos": "video",
  "{name}: only pictures and MP4 or MOV videos.": "{name}: vetëm foto dhe video MP4 ose MOV.",
  "{n} photos and videos filed on this job": "{n} foto dhe video te kjo punë",
  "{n} waiting on this device": "{n} në pritje në këtë pajisje",
  "here": "këtu",
  "1 thing happened since you last looked.": "1 gjë ndodhi që kur shikove herën e fundit.",
  "A photo from the field": "Një foto nga terreni",
  "A video from the field": "Një video nga terreni",
  "About (job, client, boat…)": "Për (punën, klientin, varkën…)",
  "Activity works with live VERA.": "Aktiviteti punon me VERA-n e vërtetë.",
  "Add a field to the Day log for ": "Shto një fushë te Ditari për ",
  "Add a field with VERA": "Shto një fushë me VERA-n",
  "Add to the log": "Shto te ditari",
  "Catch me up": "Më përditëso",
  "Catch me up: what happened since I last looked, by time and person, and what still needs me?": "Më përditëso: çfarë ndodhi që kur shikova herën e fundit, sipas orës dhe personit, dhe çfarë më pret ende?",
  "Everyone": "Të gjithë",
  "For example: Mike replaced the impeller on Sea Breeze": "P.sh.: Mike ndërroi pompën te Sea Breeze",
  "In the log.": "U shtua te ditari.",
  "Kind": "Lloji",
  "Nothing yet today. Tell VERA what happened, or add it to the log.": "Ende asgjë sot. Tregoji VERA-s çfarë ndodhi, ose shtoje te ditari.",
  "Search the log": "Kërko te ditari",
  "Teams chat": "Bisedë në Teams",
  "The Day log is a list like any other: ask VERA to add a field to it (a job, a boat, hours spent, a signature) and it's there for everyone.": "Ditari është një listë si çdo tjetër: kërkoji VERA-s t'i shtojë një fushë (një punë, një varkë, orët, një nënshkrim) dhe është aty për të gjithë.",
  "The day's log and backlog: what happened, who did it and when, so nobody misses anything. VERA keeps it as you tell her.": "Ditari i ditës: çfarë ndodhi, kush e bëri dhe kur, që askush të mos humbasë asgjë. VERA e mban ndërsa i tregon.",
  "What did {who} do {when}? Briefly, by time.": "Çfarë bëri {who} {when}? Shkurt, sipas orës.",
  "What did {who} do?": "Çfarë bëri {who}?",
  "What happened": "Çfarë ndodhi",
  "Yesterday": "Dje",
  "{n} things happened since you last looked.": "{n} gjëra ndodhën që kur shikove herën e fundit.",
  "Everything": "Gjithçka",
  "Day log": "Ditari",
  "Alerts": "Njoftimet",
  "This week": "Këtë javë",
  "Work done": "Punë e bërë",
  "Call": "Telefonatë",
  "Visit": "Vizitë",
  "Delivery": "Dorëzim",
  "Problem": "Problem",
  "Meeting": "Takim",
  "Add a transcript": "Shto një transkript",
  "Add images": "Shto foto",
  "Also update the records from it": "Përditëso edhe regjistrat prej tij",
  "Category": "Kategoria",
  "Change": "Ndrysho",
  "Date": "Data",
  "Delete {name} for good?": "Ta fshij {name} përgjithmonë?",
  "Drop anything here": "Lësho çdo gjë këtu",
  "Every document, picture and transcript, organised by job, category, people and date. VERA keeps the originals, sorts them onto your records and learns from them. Photos from the glasses are in VERA Field.": "Çdo dokument, foto dhe transkript, i renditur sipas punës, kategorisë, njerëzve dhe datës. VERA ruan origjinalet, i lidh me regjistrat dhe mëson prej tyre. Fotot nga syzet janë te VERA Field.",
  "Filed on": "Vendosur te",
  "Filed on…": "Vendosur te…",
  "Library": "Biblioteka",
  "Look at the file \"{name}\" in the Library: what does it say, and what should happen next?": "Shiko skedarin \"{name}\" te Biblioteka: çfarë thotë, dhe çfarë duhet bërë më pas?",
  "Not filed on a record yet": "Ende pa u lidhur me një regjistër",
  "Nothing here yet. Drop your first documents above, and VERA sorts them.": "Ende asgjë këtu. Lësho dokumentet e para më lart dhe VERA i rendit.",
  "Open the record": "Hap regjistrin",
  "Organise by": "Rendit sipas",
  "Paste the transcript of a call, a meeting or a voice note. VERA files it and pulls out what matters.": "Ngjit transkriptin e një telefonate, takimi ose mesazhi me zë. VERA e ruan dhe nxjerr çfarë ka rëndësi.",
  "Quotes, invoices, work orders, manuals, contracts, photos, transcripts. VERA keeps the original and sorts it onto the right job, client or boat.": "Oferta, fatura, urdhra pune, manuale, kontrata, foto, transkripte. VERA ruan origjinalin dhe e lidh me punën, klientin ose varkën e duhur.",
  "Save the transcript": "Ruaj transkriptin",
  "Search the Library": "Kërko te Biblioteka",
  "Sort it": "Rendite",
  "The Library works with live VERA.": "Biblioteka punon me VERA-n e vërtetë.",
  "Transcript": "Transkript",
  "VERA is reading {name}…": "VERA po lexon {name}…",
  "added by": "shtuar nga",
  "{name} is larger than {max}.": "{name} është më i madh se {max}.",
  "{name} looks like a secrets file and is never sent.": "{name} duket si skedar me fjalëkalime dhe nuk dërgohet kurrë.",
  "By job": "Sipas punës",
  "By category": "Sipas kategorisë",
  "By people": "Sipas njerëzve",
  "By date": "Sipas datës",
  "Not sorted yet": "Ende pa u renditur",
  "Quote": "Ofertë",
  "Invoice": "Faturë",
  "Work order": "Urdhër pune",
  "Report": "Raport",
  "Inspection": "Inspektim",
  "Contract": "Kontratë",
  "Manual": "Manual",
  "Price list": "Lista e çmimeve",
  "Photo": "Foto",
  "Letter": "Letër",
  "Other": "Tjetër",
  "Add a tool": "Shto një mjet",
  "Ask VERA…": "Pyet VERA-n…",
  "Ask me anything about this page, or tell me what you need.": "Më pyet çdo gjë për këtë faqe, ose më thuaj çfarë të duhet.",
  "Ask us to connect {name}": "Na kërko ta lidhim {name}",
  "Can VERA use our phone number?": "A mund ta përdorë VERA numrin tonë të telefonit?",
  "Connect by MCP": "Lidh me MCP",
  "Connections": "Lidhjet",
  "Drafts titles, descriptions and replies you approve": "Harton tituj, përshkrime dhe përgjigje që i miraton ti",
  "Every kind of work VERA did for you: how many times or how long, the tokens, and what it cost. Counted as it happens; lines marked estimate use an average per use.": "Çdo lloj pune që bëri VERA për ju: sa herë ose sa gjatë, tokenët dhe sa kushtoi. Numërohet në çast; rreshtat me vlerësim përdorin një mesatare.",
  "Privacy & consent": "Privatësia dhe pëlqimi",
  "Privacy and help": "Privatësia dhe ndihma",
  "Sends texts only after you say yes": "Dërgon mesazhe vetëm pasi thua po",
  "Social & marketing": "Rrjete sociale dhe marketing",
  "Texts and call summaries to your number": "Mesazhet dhe përmbledhjet e thirrjeve te numri juaj",
  "Tool name, or https://… MCP server": "Emri i mjetit, ose serveri MCP https://…",
  "Type the tool you use, or paste an MCP server address. VERA finds it, or we connect it with you.": "Shkruaj mjetin që përdor, ose ngjit adresën e një serveri MCP. VERA e gjen, ose e lidhim bashkë me ty.",
  "What VERA did this month": "Çfarë bëri VERA këtë muaj",
  "What VERA may use (microphone, email and calendar, location) and how to reach us when something isn't right.": "Çfarë mund të përdorë VERA (mikrofoni, emaili dhe kalendari, vendndodhja) dhe si të na gjeni kur diçka nuk shkon.",
  "What could we switch off to save?": "Çfarë mund të fikim për të kursyer?",
  "What did VERA do most this month?": "Çfarë bëri VERA më shumë këtë muaj?",
  "What should I connect first?": "Çfarë të lidh së pari?",
  "What your company costs this month, line by line: what VERA did, the resources you use and what each is charged. Everything except VERANeural's fee is passed through at cost.": "Sa kushton kompania juaj këtë muaj, rresht për rresht: çfarë bëri VERA, burimet që përdorni dhe sa paguhet secili. Gjithçka përveç tarifës së VERANeural kalon me kosto.",
  "Which tool is good for what we do?": "Cili mjet është i mirë për atë që bëjmë?",
  "Why did this month cost what it did?": "Pse kushtoi kaq ky muaj?",
  "Writes show notes and episode plans you approve": "Shkruan shënime dhe plane episodesh që i miraton ti",
  "Your channel's videos, comments and statistics": "Videot, komentet dhe statistikat e kanalit",
  "Your company's channel: videos, comments and how they do, so VERA can draft titles, descriptions and replies.": "Kanali i kompanisë: videot, komentet dhe si ecin, që VERA të hartojë tituj, përshkrime dhe përgjigje.",
  "Your company's phone number: VERA reads texts and call summaries, files them on the right client and job, and drafts replies.": "Numri i telefonit të kompanisë: VERA lexon mesazhet dhe përmbledhjet e thirrjeve, i lidh me klientin dhe punën, dhe harton përgjigje.",
  "Your podcast or playlists: episodes and listeners, so VERA can write show notes and plan episodes.": "Podkasti ose listat tuaja: episodet dhe dëgjuesit, që VERA të shkruajë shënime dhe të planifikojë episode.",
  "Your shows, episodes and listener numbers": "Emisionet, episodet dhe numri i dëgjuesve",
  "{n} connected · {m} available": "{n} të lidhura · {m} në dispozicion",
  "Add people in Records → Team (name, position, phone). Then give each one the staff app here: they scan the code with their phone, set a PIN, and add it to their home screen.": "Shto njerëzit te Regjistrat → Ekipi (emri, pozicioni, telefoni). Pastaj jepi secilit aplikacionin e stafit këtu: skanojnë kodin me telefon, vendosin një PIN dhe e shtojnë në ekranin kryesor.",
  "Adds your Team, Job sites, Schedule, Time sheet and Time off lists. Then each person gets the staff app on their phone: clock in and out, the job and what was done, and time off requests.": "Shton listat Ekipi, Vendet e punës, Orari, Fleta e orëve dhe Lejet. Pastaj secili merr aplikacionin e stafit në telefon: hyrje dhe dalje, puna dhe çfarë u bë, dhe kërkesat për leje.",
  "An owner sets it up.": "E konfiguron një pronar.",
  "Approved.": "U miratua.",
  "Download for payroll (CSV)": "Shkarko për pagat (CSV)",
  "Hours": "Orët",
  "How many hours did each person work this week?": "Sa orë punoi secili këtë javë?",
  "In": "Hyrja",
  "Out": "Dalja",
  "Last week": "Javën e kaluar",
  "This month": "Këtë muaj",
  "Map": "Harta",
  "No one on the team yet.": "Ende askush në ekip.",
  "No time off requested yet. People ask for it in the staff app.": "Ende pa kërkesa për leje. Njerëzit i kërkojnë në aplikacionin e stafit.",
  "No time recorded in these days.": "Asnjë orë e regjistruar në këto ditë.",
  "Nobody is clocked in right now.": "Tani askush nuk është në punë.",
  "Set up Workforce": "Konfiguro fuqinë punëtore",
  "Setting up…": "Po konfigurohet…",
  "Since": "Që nga",
  "Team ({n})": "Ekipi ({n})",
  "Time off ({n} to decide)": "Lejet ({n} për vendim)",
  "Time off": "Lejet",
  "Time sheets": "Fletët e orëve",
  "What was done": "Çfarë u bë",
  "Who's off next week?": "Kush mungon javën e ardhshme?",
  "Who's working right now, and where?": "Kush po punon tani, dhe ku?",
  "Workforce is set up. Add your team, then give each person the staff app.": "Fuqia punëtore u konfigurua. Shto ekipin, pastaj jepi secilit aplikacionin e stafit.",
  "Workforce works with live VERA.": "Fuqia punëtore punon me VERA-n e vërtetë.",
  "Workforce": "Fuqia punëtore",
  "Working now ({n})": "Në punë tani ({n})",
  "Your crew's time, simply: who's working now and where, time sheets by week or month, and time off. They clock in and out on their phones with the staff app.": "Koha e ekipit, thjesht: kush po punon tani dhe ku, fletët e orëve sipas javës ose muajit, dhe lejet. Hyjnë dhe dalin me telefon përmes aplikacionit të stafit.",
  "{m} m from the job site": "{m} m nga vendi i punës",
  "Privacy, help and signing out": "Privatësia, ndihma dhe dalja",
  "VERA is here": "VERA është këtu",
  "{n} time off to decide": "{n} leje për vendim",
  "Set weather": "Vendos motin",
  "Add a person": "Shto një person",
  "Add your people": "Shto njerëzit",
  "Email (optional)": "Email (opsionale)",
  "Give each one the staff app": "Jepi secilit aplikacionin e stafit",
  "How Workforce works": "Si punon fuqia punëtore",
  "Name": "Emri",
  "Phone": "Telefoni",
  "Position": "Pozicioni",
  "Then give each one the staff app: they scan the code with their phone, set a PIN, and add it to their home screen.": "Pastaj jepi secilit aplikacionin e stafit: skanojnë kodin me telefon, vendosin një PIN dhe e shtojnë në ekranin kryesor.",
  "They clock in and out on the phone": "Hyjnë dhe dalin me telefon",
  "below, in Team: name, position and phone.": "më poshtë, te Ekipi: emri, pozicioni dhe telefoni.",
  "on their phone: a code you show them as a QR, they set a PIN and add it to their home screen.": "në telefon: një kod që ua tregon si QR, vendosin një PIN dhe e shtojnë në ekranin kryesor.",
  "with the job, what they did and where they are; you see it here, live, and the hours add up by week and month.": "me punën, çfarë bënë dhe ku ndodhen; ti e sheh këtu drejtpërdrejt, dhe orët mblidhen sipas javës dhe muajit.",
  "{name} is on the team. Give them the staff app below.": "{name} është në ekip. Jepi aplikacionin e stafit më poshtë.",
  "Let's talk about this:": "Le të flasim për këtë:",
  "What do you know about it, and what would you do first?": "Çfarë di për këtë, dhe çfarë do të bëje e para?",
  "Talk with VERA": "Fol me VERA-n",
  "Clear it": "Hiqe",
  "Deadline saved.": "Afati u ruajt.",
  "Deadline removed.": "Afati u hoq.",
  "Proposal deadlines": "Afatet e propozimeve",
  "Add, change or remove the deadline of each open proposal. VERA reminds you as they come close.": "Shto, ndrysho ose hiq afatin e çdo propozimi të hapur. VERA të kujton kur afrohen.",
  "No open proposals.": "Asnjë propozim i hapur.",
  "Proposals": "Propozimet",
  "Deadline": "Afati",
  "Remove the deadline": "Hiq afatin",
  "Previous week": "Java e kaluar",
  "Previous month": "Muaji i kaluar",
  "Next week": "Java tjetër",
  "Next month": "Muaji tjetër",
  "Sort": "Rendit",
  "Sort by": "Rendit sipas",
  "As added": "Si u shtuan",
  "Last changed": "Ndryshuar së fundi",
  "Change the order": "Ndrysho renditjen",
  "Z to A": "Z në A",
  "A to Z": "A në Z",
  "Filter": "Filtro",
  "Filter by": "Filtro sipas",
  "Any": "Çdo",
  "Back to as added, everything": "Kthehu si u shtuan, të gjitha",
  "Sort by this": "Rendit sipas kësaj",
  "You and VERA": "Ti dhe VERA",
  "Only you see this.": "Këtë e sheh vetëm ti.",
  "How you use the platform": "Si e përdor platformën",
  "Days active (last 14)": "Ditë aktive (14 të fundit)",
  "Pages you use": "Faqet që përdor",
  "Things handled from your three": "Gjëra të trajtuara nga të trejat",
  "Times you talked or typed to VERA": "Herë që i fole ose i shkrove VERA-s",
  "How well VERA knows you": "Sa mirë të njeh VERA",
  "VERA is still getting to know how you work. Keep going as usual.": "VERA ende po mëson si punon. Vazhdo si zakonisht.",
  "VERA forgets this": "VERA e harron këtë",
  "What VERA keeps from your records and emails is in Settings → What VERA remembers.": "Çfarë mban VERA nga regjistrat dhe emailet e tua është te Cilësimet → Çfarë mban mend VERA.",
  "What VERA changed and suggests": "Çfarë ndryshoi dhe sugjeron VERA",
  "Around the platform": "Rreth platformës",
  "How VERA is learning, per company": "Si po mëson VERA, sipas kompanisë",
  "Totals only, never a person's details": "Vetëm totale, kurrë detajet e një personi",
  "No one yet.": "Ende askush.",
  "Company": "Kompania",
  "People": "Njerëz",
  "Usage": "Përdorimi",
  "Knows": "Njeh",
  "Undo it in Operations.": "Zhbëje te Operacionet.",
};
